<template>
    <div>
        <div class="ku-article-layout" v-auto-pageview="true">
            <div class="ku-article-left">
                <div class="ku-article-bread-wraper">
                    <div class="ku-article-bread">
                        <div
                            class="ku-article-bread-item"
                            :class="{ active: item.id == query.topicType }"
                            v-for="item in leftTopics"
                            :key="item.id"
                            @click="go2Topic(item.id)"
                            v-track-event.click="'论坛,' + item.name + ',点击'"
                        >
                            <div class="ku-article-bread-item-icon" v-if="item.id == query.topicType">
                                <img :src="item.active" />
                            </div>
                            <div class="ku-article-bread-item-icon" v-else><img :src="item.icon" /></div>
                            <div class="ku-article-bread-item-text">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <section v-if="active != 100" class="flex">
                <div class="ku-article-center" style="width: calc(1200px - 180px - 300px - 40px)">
                    <div class="ku-article-body">
                        <div class="ku-article-search">
                            <div class="ku-article-search-input">
                                <el-input
                                    style="width: 100%"
                                    clearable
                                    placeholder="请输入想看的内容标题"
                                    v-model="query.title"
                                    class="input-with-select-input"
                                    @change="delayChange"
                                >
                                    <el-button class="input-with-select-btn-input" slot="append" @click="delayChange">
                                        <i class="el-icon-search"></i>
                                        搜索
                                    </el-button>
                                </el-input>
                            </div>
                            <div class="ku-article-search-tabs" v-if="topics.length">
                                <el-tabs type="card" v-model="query.sectionId" @tab-click="topicsTabClick">
                                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                                    <el-tab-pane
                                        v-for="item in topics"
                                        :key="item.sectionId"
                                        :label="item.sectionName"
                                        :name="item.sectionId"
                                    ></el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                        <div class="ku-article-filter" v-if="query.topicType != 99">
                            <div class="ku-article-search-box" v-if="query.topicType == 0">
                                <el-select
                                    class="ku-article-search-select"
                                    v-model="query.postId"
                                    placeholder="请输入岗位名称"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    style="width: 210px; height: 34px"
                                    :remote-method="queryPost"
                                    @change="change"
                                >
                                    <el-option
                                        v-for="item in postOpts"
                                        :key="item.postId"
                                        :label="item.postName"
                                        :value="item.postId"
                                    />
                                </el-select>
                                <el-select
                                    class="ku-article-search-select"
                                    v-model="query.companyId"
                                    placeholder="请输入公司名称"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    style="width: 210px; height: 34px"
                                    :remote-method="queryCompany"
                                    @change="change"
                                >
                                    <el-option
                                        v-for="item in companyOpts"
                                        :key="item.companyId"
                                        :label="item.companyName"
                                        :value="item.companyId"
                                    />
                                </el-select>
                            </div>
                            <el-tabs v-model="indicator" @tab-click="indicatorTabClick">
                                <el-tab-pane label="最新" name="2" :disabled="isLoading"></el-tab-pane>
                                <el-tab-pane label="推荐" name="1" :disabled="isLoading"></el-tab-pane>
                                <!-- <el-tab-pane v-if="token" label="收藏" name="3" :disabled="isLoading"></el-tab-pane> -->
                            </el-tabs>
                        </div>
                    </div>
                    <ku-article-card :post-item="list" @go-detail="goDetail" @do-remove="doRemove"></ku-article-card>
                    <div class="work-detail-empty-article" v-if="isEmpty">
                        <img class="work-detail-empty-img" src="@/assets/nodata/queshengye.png" />
                        <div class="work-detail-empty-text">{{ emptyText }}</div>
                    </div>
                </div>
                <div class="ku-article-right">
                    <div class="ku-article-hot">
                        <div class="ku-article-hot-section">
                            <ku-article-create :post-draft="articleNum"></ku-article-create>
                        </div>
                        <div class="ku-article-hot-section" v-if="hotList.length">
                            <ku-article-hot :post-items="hotList" @go-detail="goDetail"></ku-article-hot>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 求职时间轴 -->
            <section v-if="active == 100">
                <ku-article-timeline></ku-article-timeline>
            </section>
        </div>
        <div class="back-top-wraper">
            <el-backtop>
                <div class="back-top-image">
                    <img src="@/assets/bbs/zhiding.png" />
                </div>
            </el-backtop>
        </div>
        <div v-if="token" style="display: none"></div>
    </div>
</template>

<script>
import gengduo from "@/assets/article/gengduo.png"
import mianjing from "@/assets/article/mianjing.png"
import richang from "@/assets/article/richang.png"
import xiangmu from "@/assets/article/xiangmu.png"
import xuexi from "@/assets/article/xuexi.png"
import shijianzhou from "@/assets/article/shijianzhou.png"
import shoucang from "@/assets/article/shoucang.png"
import xzxg from "@/assets/article/xzxg.png"
import xxjy from "@/assets/article/xxjy.png"
import lsjy from "@/assets/article/lsjy.png"
import gengduoactive from "@/assets/article/gengduo-active.png"
import mianjingactive from "@/assets/article/mianjing-active.png"
import richangactive from "@/assets/article/richang-active.png"
import xiangmuactive from "@/assets/article/xiangmu-active.png"
import xuexiactive from "@/assets/article/xuexi-active.png"
import shijianzhouactive from "@/assets/article/shijianzhou-active.png"
import shoucangactive from "@/assets/article/shoucang-active.png"
import xzxgactive from "@/assets/article/xzxgactive.png"
import xxjyactive from "@/assets/article/xxjyactive.png"
import lsjyactive from "@/assets/article/lsjyactive.png"
import { mapGetters } from "vuex"
import KuArticleCreate from "./ku-article-create"
import KuArticleHot from "./ku-article-hot"
import KuArticleCard from "./ku-article-card"
import KuArticleTimeline from "./ku-article-timeline"
import { getTopicTypeList, getRecentList, getHotList, getCollectList, getTopicTypes, getTopList } from "@/api/article"
import { searchMajor, searchCompany } from "@/api/request"
import { getArticleNum } from "@/api/bbs"
import throttle from "throttle-debounce/throttle"

export default {
    name: "ku-article-layout",
    components: { KuArticleCreate, KuArticleHot, KuArticleCard, KuArticleTimeline },
    data() {
        const { query } = this.$route
        const { companyName, companyId, topicId } = query
        const companyOpts = []
        if (companyName && companyId) {
            companyOpts.push({ companyName, companyId })
        }
        return {
            isLoading: false,
            companyOpts,
            postOpts: [],
            topics: [],
            indicator: "2",
            query: {
                pageNum: 1,
                pageSize: 10,
                schoolId: "",
                sectionId: "0",
                companyId: companyId ? companyId : "",
                postId: "",
                topicType: topicId || 0,
                title: "",
                sectionUnionId: "0",
            },
            leftTopics: [],
            list: [],
            hotList: [],
            articleNum: 0,
            emptyText: "暂无数据",
        }
    },
    computed: {
        ...mapGetters(["token"]),
        isEmpty() {
            return this.list.length == 0 && this.total <= 0
        },
    },
    created() {
        this.getTopicList()
        this.active = this.query.topicType
        if (this.query.topicType != 100) this.getList(this.query)
        if (this.query.topicType == 0) {
            this.getTopics()
        }
        this.getHotSepList()
        if (this.token) {
            this.getArticleNumFun()
        }
    },
    mounted() {
        this.init()
        this.throttledScrollHandler = throttle(300, this.onScroll)
        this.container.addEventListener("scroll", this.throttledScrollHandler)
    },
    beforeDestroy() {
        this.container.removeEventListener("scroll", this.throttledScrollHandler)
    },
    methods: {
        doRemove(row) {
            const index = this.list.indexOf(row)
            const { topicType } = this.query
            if (index > -1 && topicType == 99) {
                this.list.splice(index, 1)
                this.total--
            }
        },
        // 跳转至详情页面
        goDetail(row) {
            let topicType = ""
            !row.topicType && row.topicType !== 0 ? (topicType = "") : (topicType = row.topicType)
            const { href } = this.$router.resolve(`/bbs/detail/${row.topicId}/${topicType}`)
            window.open(href)
        },
        delayChange() {
            window.clearTimeout(this.timer)
            this.timer = window.setTimeout(() => {
                this.change()
            }, 300)
        },
        getArticleNumFun() {
            return getArticleNum().then(res => {
                this.articleNum = res.data.draft || 0
            })
        },
        go2Detail(row) {
            const { href } = this.$router.resolve(`/bbs/detail/${row.topicId}/${this.query.topicType}`)
            window.open(href)
        },
        init() {
            this.container = document
            this.el = document.documentElement
        },
        isReachBottom() {
            const currentTop = this.el.scrollTop
            if (currentTop - this.lastTop > 0) {
                // down
                return this.el.scrollHeight - 600 <= this.el.scrollTop + this.el.clientHeight
            }
            this.lastTop = currentTop
            return false
        },
        onScroll() {
            if (this.isLoading) {
                return
            }
            // const isReachBottom = this.el.scrollHeight - 600 <= this.el.scrollTop + this.el.clientHeight
            if (this.isReachBottom()) {
                this.isLoading = true
                this.getList(this.query)
            }
        },
        indicatorTabClick() {
            this.list = []
            this.total = 0
            this.query.pageNum = 1
            this.isLoading = true // 禁用滚动调
            this.el.scrollTop = 0
            return this.getList(this.query)
        },
        queryCompany(text) {
            window.clearTimeout(this.timer)
            this.timer = window.setTimeout(() => {
                this.getCompany(text)
            }, 300)
        },
        queryPost(text) {
            window.clearTimeout(this.timer)
            this.timer = window.setTimeout(() => {
                this.getPost(text)
            }, 300)
        },
        getPost(text) {
            return searchMajor(text).then(resp => {
                this.postOpts = resp.data || []
            })
        },
        getCompany(text) {
            return searchCompany(text).then(resp => {
                this.companyOpts = resp || []
            })
        },
        topicsTabClick() {
            const { sectionId } = this.query
            const [result] = this.topics.filter(item => item.sectionId == sectionId)
            this.list = []
            this.total = 0
            this.query.pageNum = 1
            if (result) {
                this.query.sectionUnionId = result.unionId
            } else {
                this.query.sectionId = "0"
                this.query.sectionUnionId = "0"
            }
            this.isLoading = true // 禁用滚动调
            this.el.scrollTop = 0

            return this.getList(this.query)
        },
        go2Topic(topicId) {
            this.active = topicId
            this.query.topicType = topicId
            this.$router.push({
                path: "/reload",
                query: {
                    redirect: "/bbs/index",
                    topicId,
                },
            })
        },
        getHotSepList() {
            return getTopList().then(resp => {
                this.hotList = resp.data
            })
        },
        getList(query) {
            if (this.total < this.query.pageSize && this.list.length) {
                this.isLoading = false
                return Promise.resolve(false)
            }
            this.isLoading = true
            const indicator = this.indicator
            const { topicType } = this.query
            if (topicType == 99) {
                return this.getStoreList(query).finally(() => {
                    this.isLoading = false
                    if (!this.list.length) {
                        this.emptyText = "暂无数据"
                    }
                })
            }
            if (indicator == 1) {
                return this.getHotList(query).finally(() => {
                    this.isLoading = false
                    if (!this.list.length) {
                        this.emptyText = "暂无数据"
                    }
                })
            }
            if (indicator == 2) {
                return this.getNewList(query).finally(() => {
                    this.isLoading = false
                    if (!this.list.length) {
                        this.emptyText = "暂无数据"
                    }
                })
            }
            // if (indicator == 3) {
            //     return this.getStoreList(query).finally(() => {
            //         this.isLoading = false
            //         if (!this.list.length) {
            //             this.emptyText = "暂无数据"
            //         }
            //     })
            // }
        },
        // getList4Stroe(params) {
        //     return getStoreList(params).then(resp => {
        //         debugger
        //         const { rows = [] } = resp || {}
        //         this.list = this.list.concat(rows)
        //         this.total = rows.length
        //         this.query.pageNum++
        //     })
        // },
        getHotList(query) {
            return getHotList(query).then(resp => {
                const { rows } = resp
                this.total = rows.length
                this.list = this.list.concat(rows)
                // this.list.map(item => {
                //     const { srcList, content } = item
                //     if (!srcList) {
                //         const imgs = this.parseHtml(content)
                //         item.filelist = imgs.slice(0, 6)
                //         item.srcList = imgs
                //         console.log(item.filelist)
                //     }
                //     return item
                // })
                this.query.pageNum++
            })
        },
        getNewList(query) {
            return getRecentList(query).then(resp => {
                const { rows } = resp
                this.total = rows.length
                this.list = this.list.concat(rows)
                this.query.pageNum++
            })
        },
        getStoreList(query) {
            return getCollectList(query).then(resp => {
                const { rows } = resp
                this.total = rows.length
                this.list = this.list.concat(rows)
                this.list.map(element => {
                    if (!element.briefContent && (!element.imageList || element.imageList.length === 0)) {
                        element.collectCount = 1
                        element.collect = true
                    }
                })
                this.query.pageNum++
            })
        },
        getTopics() {
            return getTopicTypes(this.query.topicType).then(resp => {
                this.topics = resp.data
            })
        },
        getTopicList() {
            return getTopicTypeList().then(resp => {
                // topicType  topicTypeName
                this.leftTopics = (resp.data || []).map(item => {
                    const { topicType, topicTypeName } = item
                    if (topicType == 100) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: shijianzhou,
                            active: shijianzhouactive,
                        }
                    }
                    if (topicType == 0) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: mianjing,
                            active: mianjingactive,
                        }
                    }
                    if (topicType == 1) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: xuexi,
                            active: xuexiactive,
                        }
                    }
                    if (topicType == 2) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: xiangmu,
                            active: xiangmuactive,
                        }
                    }
                    if (topicType == 3) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: richang,
                            active: richangactive,
                        }
                    }
                    if (topicType == 4) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: gengduo,
                            active: gengduoactive,
                        }
                    }
                    if (topicType == 5) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: gengduo,
                            active: gengduoactive,
                        }
                    }
                    if (topicType == 99) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: shoucang,
                            active: shoucangactive,
                        }
                    }
                    if (topicType == 98) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: xzxg,
                            active: xzxgactive,
                        }
                    }
                    if (topicType == 97) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: xxjy,
                            active: xxjyactive,
                        }
                    }
                    if (topicType == 96) {
                        return {
                            name: topicTypeName,
                            id: topicType,
                            icon: lsjy,
                            active: lsjyactive,
                        }
                    }
                    return {
                        name: topicTypeName,
                        id: topicType,
                        icon: gengduo,
                        active: gengduoactive,
                    }
                })
            })
        },
        change() {
            this.query.pageNum = 1
            this.total = 0
            this.list = []
            this.el.scrollTop = 0
            this.isLoading = true
            this.$nextTick(() => {
                this.getList(this.query)
            })
        },
    },
}
</script>

<style lang="scss">
.work-detail-empty-article {
    margin-top: 20px;

    img {
        width: 538px;
        height: 305px;
    }
}

.ku-article-search-input {
    .el-input__inner {
        height: 34px;
        border: none;
        background-color: #f7f7f7;
    }

    .el-input-group__append {
        .input-with-select-btn-input {
            width: 88px;
            height: 34px;
            background: #24c68b;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            padding: 0;
        }
    }
}

.work-detail-empty-article {
    text-align: center;
    background: #fff;
    padding: 60px 0;
    font-size: 16px;
    font-weight: 500;
    color: #999999;
    border-radius: 10px;
    margin-left: 20px;
}

.ku-article-search-box {
    margin-bottom: 20px;

    .el-input__inner {
        height: 35px;
    }

    .el-icon-circle-close {
        height: 35px;
        line-height: 35px;
    }

    .ku-article-search-select {
        margin-right: 20px;
    }
}

.back-top-wraper {
    .el-backtop {
        width: 55px !important;
        height: 55px !important;
    }

    .back-top-image {
        width: 55px;
        height: 55px;
        border-radius: 55px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.ku-article-layout {
    display: flex;
    padding-top: 30px;
    width: 1200px;
    margin: 0 auto 90px;

    .ku-article-left {
        width: 180px;
        border-radius: 10px;
        flex: none;
    }

    .ku-article-center {
        flex: 1;
        border-radius: 10px;
    }

    .ku-article-right {
        width: 300px;
        margin-left: auto;
        margin-right: 0;
        border-radius: 10px;
    }
}

.ku-article-bread-wraper {
    overflow: hidden;
    background-color: #fff;
    border-radius: 10px;
}

.ku-article-bread {
    margin: 16px 7px 16px 9px;

    .ku-article-bread-item {
        display: flex;
        align-items: center;
        padding: 11px 17px;
        cursor: pointer;
        border-radius: 5px;
    }

    .ku-article-bread-item-icon {
        width: 16px;
        height: 16px;
        margin-right: 15px;

        img {
            width: 100%;
            height: 100%;
            vertical-align: top;
        }
    }

    .ku-article-bread-item-text {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
    }

    .ku-article-bread-item:hover {
        background: #f7f7f7;
    }

    .ku-article-bread-item.active {
        background: #e9f9f3;

        .ku-article-bread-item-text {
            color: #24c68b;
        }
    }
}

.ku-article-search-tabs {
    margin-top: 20px;

    .el-tabs__content {
        display: none !important;
    }

    .el-tabs__item {
        padding: 0 16px;
        height: auto;
        line-height: normal;
        border: none !important;
        background: #f7f7f7;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-right: 20px;
        padding: 2px 12px !important;
    }

    .el-tabs__item.is-active {
        background: #24c68b;
        font-size: 14px;
        color: #ffffff;
    }

    .el-tabs__header {
        border-bottom: none !important;
        margin-bottom: 0;
    }

    .el-tabs__nav {
        border: none !important;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
        line-height: normal;
    }
}

.ku-article-filter {
    .el-tabs__content {
        display: none !important;
    }

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__nav-wrap::after {
        display: none !important;
    }

    .el-tabs__item {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
    }

    .el-tabs__item.is-active {
        font-size: 16px;
        font-weight: 600;
        color: #24c68b;
    }

    .el-tabs__active-bar {
        background-color: #24c68b;
    }
}

.ku-article-search {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
}

.ku-article-filter {
    margin: 10px 0;
    background-color: #fff;
    padding: 10px 24px 4px;
    border-radius: 10px;
}

.ku-article-body {
    margin-left: 20px;
    margin-bottom: 20px;
}

.ku-article-hot {
    margin-left: 20px;

    .ku-article-hot-section {
        margin-bottom: 14px;
    }
}

.flex {
    display: flex;
}
</style>
